import { Address, NewAddress } from '../location/address'

export class Gender {
    code: string
    description?: string

    constructor(code: string, description?: string) {
        this.code = code
        this.description = description
    }
}

//SCMT 2.0
// 17-07-2024 NewProfile funtion start

export class NewProfile {
    firstName : string
    mobile : string
    email? : string
    address? : NewAddress
    

    constructor( firstName : string, mobile : string, email? : string, address? : NewAddress) {
        this.firstName = firstName
        this.mobile = mobile
        this.email = email
        this.address = address
    }
}
// 17-07-2024 NewProfile funtion end


export class Profile {
    firstName: string
    lastName: string
    gender: Gender
    dob: Date
    mobile: string
    address?: Address
    email?: string

    constructor(firstName: string, lastName: string, gender: Gender, dob: Date, mobile: string, address?: Address, email?: string) {
        this.firstName = firstName
        this.lastName = lastName
        this.gender = gender
        this.dob = dob
        this.mobile = mobile
        this.address = address
        this.email = email
    }
}